import { requestActions } from "./utils";

export const MFA_INFO = requestActions("Auth/MFA/Info");
export const MFA_LOGIN = requestActions("Auth/MFA/Login");
